export const propertyType = [
  { id: 1, label: 'Room', value: 'room' },
  { id: 2, label: 'House', value: 'house' },
  { id: 3, label: 'Flat', value: 'flat' },
  { id: 4, label: 'Girls PG', value: 'girls_pg' },
  { id: 5, label: 'Boys PG', value: 'boys_pg' },
  { id: 6, label: 'Co-living', value: 'co_living' },
  // { id: 7, label: 'Vila', value: 'vila' },
];

export const dealType = [
  { id: 1, label: 'Rent', value: 'rent', searchLabel: 'Rent' },
  { id: 2, label: 'Buy', value: 'sell', searchLabel: 'Buy' },
];

export const dealTypeEnum ={
  Rent: 'rent',
  Sell: 'sell',
}

export const dealPropertyType = [
  { id: 1, label: 'Flat', value: 'flat' },
  { id: 2, label: 'House', value: 'house' },
  { id: 3, label: 'Villa', value: 'Villa' },
];

export const popularPropertySearch = [
  { id: 1, label: 'Room', value: 'room' },
  { id: 2, label: 'House', value: 'house' },
  { id: 3, label: 'Flat', value: 'flat' },
  { id: 6, label: 'Co-living', value: 'co_living' },
];

export const proprertyViewData: any = {
  room: 'Room',
  house: 'House',
  flat: 'Flat',
  girls_pg: 'Girls PG',
  boys_pg: 'Boys PG',
  co_living: 'Co-Living',
  Villa: 'Villa',
};

export const proprertyPriceRange = [
  { Id: 1, Name: 'No Price', MaxValue: 99999999, MinValue: 0 },
  { Id: 2, Name: '< ₹1000', MaxValue: 1000, MinValue: 0 },
  { Id: 3, Name: '₹1000- ₹3000', MaxValue: 3000, MinValue: 1000 },
  { Id: 4, Name: '₹3000- ₹7000', MaxValue: 7000, MinValue: 3000 },
  { Id: 5, Name: '₹7000- ₹10000', MaxValue: 10000, MinValue: 7000 },
  { Id: 6, Name: '₹10000- ₹15000', MaxValue: 15000, MinValue: 10000 },
  { Id: 7, Name: '₹15000- ₹25000', MaxValue: 25000, MinValue: 15000 },
  { Id: 8, Name: '> ₹25000', MaxValue: 99999999, MinValue: 25000 },
];


export const sellProprertyPriceRange = [
  { Id: 1, Name: 'No Price', MaxValue: 99999999, MinValue: 0 },
  { Id: 2, Name: '< ₹2000000', MaxValue: 2000000, MinValue: 0 },
  { Id: 3, Name: '₹2000000- ₹3500000', MaxValue: 3500000, MinValue: 2000000 },
  { Id: 4, Name: '₹3500000- ₹7000000', MaxValue: 7000000, MinValue: 3500000 },
  { Id: 5, Name: '₹7000000- ₹10000000', MaxValue: 10000000, MinValue: 7000000 },
  { Id: 6, Name: '₹10000000- ₹15000000', MaxValue: 15000000, MinValue: 10000000 },
  { Id: 7, Name: '₹15000000- ₹25000000', MaxValue: 25000000, MinValue: 15000000 },
  { Id: 8, Name: '> ₹25000000', MaxValue: 99999999, MinValue: 25000000 },
];

export const proprertyPriceFieldValue = proprertyPriceRange.map((e) => ({
  value: e.Id,
  label: e.Name,
}));

export const sellProprertyPriceFieldValue = sellProprertyPriceRange.map((e) => ({
  value: e.Id,
  label: e.Name,
}));

export const getProprertyPrice = (id: number, dealType: string) =>
  dealType === dealTypeEnum.Sell
    ? sellProprertyPriceRange.find((e) => e.Id === id)
    : proprertyPriceRange.find((e) => e.Id === id);
